module.exports = __webpack_public_path__ + "static/media/binary-1bit.970010fb.gif";